<template>
  <section id=music>
    <h1>Music</h1>
    <iframe
      width=600 height=600 scrolling=no frameborder=no
      :src="playerUrl"
    ></iframe>
  </section>
</template>

<script>
export default {
  name: 'Music',
  data() {
    const playerUrl = 'https://w.soundcloud.com/player/?'
      + 'url=https%3A//api.soundcloud.com/playlists/155381610%3Fsecret_token%3Ds-Awjjz'
      + '&amp;amp;auto_play=true'
      + '&amp;amp;hide_related=false'
      + '&amp;amp;show_comments=true'
      + '&amp;amp;show_user=true'
      + '&amp;amp;show_reposts=false'
      + '&amp;amp;visual=true';

    return {
      playerUrl,
    };
  },
};
</script>
